import uuid from 'uuid/v1';
import { INDICATION_TYPES } from 'taboola-ultimate-ui';
import { CREATIVE_TYPE } from 'modules/campaigns/config';
import { generateCreativeEditorPath } from 'modules/campaigns/services/utils';
import { addIndication, removeIndication } from 'modules/taboola-common-frontend-modules/Indications';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { mergeQueryParams } from 'modules/taboola-common-frontend-modules/query-params';
import { INITIAL_CREATIVE_TYPE } from '../../creative-editor/hooks/useInitialCreativeType';

const SUCCESS_MESSAGE_ID = 'creative.creator.display.social.success.info.indication';
const SUCCESS_MESSAGE_DEFAULT = 'Your ad has been successfully imported and is ready for review. {link}';
const SUCCESS_LINK_ID = 'creative.creator.display.social.success.info.link';
const SUCCESS_LINK_DEFAULT = '<b>View Ad</b>';
const FAILURE_MESSAGE_ID = 'creative.creator.display.social.failure.info.indication';
const FAILURE_MESSAGE_DEFAULT =
    "We couldn't import your ad. This might be due to connection issues or invalid ad ID. {link}";
const FAILURE_LINK_ID = 'creative.creator.display.social.failure.info.link';
const FAILURE_LINK_DEFAULT = '<b> Try Again </b>';

const generateInfoIndication = (
    navigate,
    dispatch,
    pathWithCreativeType,
    id,
    messageId,
    messageDefault,
    linkMessageId,
    linkMessageDefault
) => ({
    message: (
        <FormattedMessage
            id={messageId}
            defaultMessage={messageDefault}
            values={{
                link: (
                    <span
                        style={{ cursor: 'pointer', textDecoration: 'underline' }}
                        onClick={() => {
                            navigate(pathWithCreativeType);
                            dispatch(removeIndication({ id }));
                        }}
                    >
                        <FormattedMessage id={linkMessageId} defaultMessage={linkMessageDefault} />
                    </span>
                ),
            }}
        />
    ),
    type: INDICATION_TYPES.INFO,
    timeoutActive: false,
    id,
});

export const handleSocialDataCallback = (data, { dispatch, navigate, account }) => {
    const { accountId } = account;
    const editCreativePath = generateCreativeEditorPath({
        accountId,
        campaignId: data.campaignId,
        creativeId: data.id,
    });

    const pathWithCreativeType = `${editCreativePath}${mergeQueryParams('', {
        [INITIAL_CREATIVE_TYPE]: CREATIVE_TYPE.DISPLAY,
    })}`;

    const indication = data?.displayData?.adTag
        ? generateInfoIndication(
              navigate,
              dispatch,
              pathWithCreativeType,
              uuid(),
              SUCCESS_MESSAGE_ID,
              SUCCESS_MESSAGE_DEFAULT,
              SUCCESS_LINK_ID,
              SUCCESS_LINK_DEFAULT
          )
        : generateInfoIndication(
              navigate,
              dispatch,
              pathWithCreativeType,
              uuid(),
              FAILURE_MESSAGE_ID,
              FAILURE_MESSAGE_DEFAULT,
              FAILURE_LINK_ID,
              FAILURE_LINK_DEFAULT
          );

    dispatch(addIndication(indication));
};
